import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=1b4b843b&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=ts&"
export * from "./Filters.vue?vue&type=script&lang=ts&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=1b4b843b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b843b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
